import { render, staticRenderFns } from "./ModalAjoutCategorie.vue?vue&type=template&id=b7c9334a&scoped=true&"
import script from "./ModalAjoutCategorie.vue?vue&type=script&lang=js&"
export * from "./ModalAjoutCategorie.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjoutCategorie.vue?vue&type=style&index=0&id=b7c9334a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c9334a",
  null
  
)

export default component.exports